import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "14",
  fill: "none",
  viewBox: "0 0 16 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.8 0c.121 0 .24.028.348.083a.8.8 0 0 1 .279.234l.06.09 2.4 4.19a.87.87 0 0 1-.026.902l-.064.087-6.825 7.987a1.4 1.4 0 0 1-.444.316A1.3 1.3 0 0 1 8 14a1.32 1.32 0 0 1-.888-.35l-.108-.105-6.8-7.96a.874.874 0 0 1-.138-.894l.049-.096L2.525.388l.051-.075A1 1 0 0 1 2.7.183L2.772.13l.07-.042.04-.02.048-.02.087-.027.09-.017L3.2 0zM5.693 3.304a.77.77 0 0 0-.606-.094.8.8 0 0 0-.491.38l-.48.839-.048.097a.87.87 0 0 0 .141.896l1.6 1.844.072.073a.78.78 0 0 0 .533.201.78.78 0 0 0 .526-.217l.07-.076A.86.86 0 0 0 7.2 6.69a.86.86 0 0 0-.208-.551l-1.2-1.383.174-.304.044-.086a.88.88 0 0 0 .034-.595.83.83 0 0 0-.352-.467"
    }, null, -1)
  ])))
}
export default { render: render }